import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, Toast } from "react-bootstrap";
import useSiteState from '../appState/siteState/useSiteState';
import TickIcon from "../assets/icons/tickicon";
import { store } from '../appState/store';


const DeletePlayerToastMessage = (props) => {

    const siteState = useSiteState();
    const siteData = store.getState().site

    const [showToastSuccess, setShowToastSuccess] = useState(false);
    const [toastSuccessMessage, setToastSuccessMessage] = useState('');
    const [toastMessageDelay, setToastMessageDelay] = useState(5000);


    useEffect(() => {
        if (!showToastSuccess) {
            setToastSuccessMessage('')
        }
    }, [showToastSuccess])

    useEffect(() => {
        if (siteState.data.Lobby.deleteResponseData && siteState.data.Lobby.deleteResponseData.errorCode == 200) {
            setShowToastSuccess(true);
            setToastSuccessMessage(siteState.data.Lobby.deleteResponseData.message)
            setTimeout(function () {
                setShowToastSuccess(false)
                setToastSuccessMessage('')
                siteState.data.Lobby.deleteResponseData = [];
            }, toastMessageDelay)
        }
    }, [siteState.data.Lobby.deleteResponseData])


    return (
        <>
            {toastSuccessMessage ? <ToastContainer position="top-end">
                <Toast className="toast-success" onClose={() => setShowToastSuccess(false)} show={showToastSuccess} delay={toastMessageDelay} >
                    <Toast.Header>
                        <TickIcon />
                    </Toast.Header>
                    <Toast.Body>{toastSuccessMessage}</Toast.Body>
                </Toast>
            </ToastContainer> : '' }
        </>

    );
};

export default DeletePlayerToastMessage;
